<script lang="ts">
	import type { BlogCategory } from "../../../core/schema/blog/blogCategory.js";
	import { blogCategoryNameMap } from "../../../core/schema/blog/blogCategory.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { getTenant } from "../getTenant.js";

	export let category: BlogCategory;

	const tenant = getTenant();
</script>

<span
	class="bg-lttertiary-100 text-ltprimary-300 font-bahnschrift text-2xs/[1.1875rem] inline-flex items-center px-2.5 py-[0.3125rem] font-medium uppercase tracking-[0.07em]"
>
	{nbspify(blogCategoryNameMap[category][tenant.locale])}
</span>
